import { FC } from 'react'
import type { AwardsModuleDiscover } from '../../../types/components'
import ModuleDiscoverPageComponent from '../ModuleDiscoverPage'
import { ApiPagePage } from '../../../types/contentTypes'

const ModuleDiscoverPage: FC<{
  moduleProps: AwardsModuleDiscover['attributes']
  landingContentData: ApiPagePage['attributes']
}> = ({ moduleProps }) => {
  return <ModuleDiscoverPageComponent moduleProps={moduleProps} />
}

export default ModuleDiscoverPage
